import { render } from "./annual.vue?vue&type=template&id=4b25a7ce&scoped=true"
import script from "./annual.vue?vue&type=script&lang=js"
export * from "./annual.vue?vue&type=script&lang=js"

import "./annual.vue?vue&type=style&index=0&id=4b25a7ce&lang=scss&scoped=true"

import exportComponent from "C:\\Programming\\Padmaweb\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b25a7ce"]])

export default __exports__